<template>
  <SearchDropdown
    :placeholder="placeholder"
    :DisplayFunction="displayFunction"
    :InitialValue="displayFunction(role)"
    :ObjKey="'id'"
    :width="width"
    :browseIcon="true"
    :pages="pages"
    :externalResults="items"
    :dropUp="dropUp"
    @selected="item => select(item)"
    @search="(txt, pg) => getList(txt, pg)"
    @none="select(null)"
    ref="search"
  />
</template>


<script>
import RolesAPI from '@/api/RolesAPI.js'
import PaginatedRequest from '@/api/PaginatedRequest.js'
import Role from '@/features/Roles/Role.js'
import SearchDropdown from '@/components/utilities/SearchDropdown.vue'

export default {
  name: 'RoleSearchDropdown',

  components: {
    SearchDropdown,
  },

  props: {
    role: {
      type: Object,
      default: null
    },

    width: {
      type: String,
      default: '50%'
    },

    placeholder: {
      type: String,
      default: 'Search Roles'
    },

		dropUp: {
			type: Boolean,
			default: false
		},

  },


  model: {
    prop: 'role',
    event: 'update'
  },

  data() {
    return {
      items: [],
      pages: 1,
    }
  },

  methods: {

    select(item) {
      this.$emit('update', item);
    },

    clear() { this.$refs.search.clear() },

    displayFunction(obj) {
      if(!obj) return '';
      return `${obj.name} (${obj.description || ""})`
    },

    async getList(searchTerm, page = 1) {
      const req = new PaginatedRequest()
      req.page = page
      req.pageSize = 25
      req.searchString = searchTerm || null
      const res = await RolesAPI.searchRoles( req )

      this.items = []
      if( !res || !res.data ) return
      this.pages = res.data.pages
      for( let item of res.data.data ) this.items.push( Role.import(item) )
    },
  }


}
</script>
